<template>

    <div class="relative">

        <div v-show="(!valid || error) && showError && backgroundColor" class="tooltip-error" @click="eventChange">
            <div class="tooltip-error-text">
                {{ errorMessage }}
            </div>
            <div class="tooltip-arrow-container">
                <div class="tooltip-arrow"></div>
            </div>
        </div>

        <div ref="inputContainer"
             :class="{
              'input-focus': inputFocus,
              'light-border': backgroundColor,
              'light-border-focus': inputFocus && backgroundColor,
              'error': error,
              'big-select': big
         }"
             class="input-container-c"
             @click="focus">

            <input
                ref="input"
                v-model="value"
                :name="name"
                :placeholder="placeholder"
                :type="compuType"
                class="input-text-c"
                type="text"
                @change="change"
                @focus="eventFocus"
                @keypress="eventChange"
                v-on:blur="onBlur"
                v-on:keyup.enter="enter"
            >

            <img v-show="valid && type !== 'password' && !error" alt="input valid"
                 class="ico-input-check" src="/img/icons/check-green.svg">

            <img v-show="type === 'password' && !error"
                 :alt="iconAlt"
                 :src="iconSource"
                 class="ico-input-check"
                 @click="encrypt = !encrypt">

            <img v-show="type === 'password' && error"
                 :alt="iconAltError"
                 :src="iconErrorSource"
                 class="ico-input-check"
                 @click="encrypt = !encrypt">
        </div>

        <div v-show="!valid && showError && !backgroundColor" class="span-error-text">
            {{ errorMessage }}
        </div>

    </div>

</template>

<script>

import {configuration} from '../../../configuration'

export default {

    name: 'input-text',

    props: {

        data: {
            type: String,
            default: ''
        },

        placeholder: {
            type: String,
            default: ''
        },

        type: {
            type: String,
            default: 'text'
        },

        valid: {
            type: Boolean,
            default: false
        },

        error: {
            type: Boolean,
            default: false
        },

        errorMessage: {
            type: String,
            default: ''
        },

        // if background is not white
        backgroundColor: {
            type: Boolean,
            default: false
        },

        boolFocus: {
            type: Boolean,
            default: false
        },

        //auto-complite
        name: {
            type: String,
            default: ''
        },

        big: {
            type: Boolean,
            default: false
        }

    },

    data() {
        return {
            value: '',
            inputFocus: false,
            encrypt: true,
            regexMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            aNumbers: '0123456789',
            regexText: /^[A-Za-z\-]+$/,
            regexNumber: /^[0-9]+$/,
            showError: false
        }
    },

    watch: {

        data: function (data) {
            this.value = data
        },

        error: function (data) {
            this.error = data
            this.showError = data
        },

        valid: function (data) {
            this.valid = data
        },

        value: function (data) {
            this.$emit('change', data)
            if (this.type === 'year') {
                this.value = data.substring(0, 4)
            }
        }

    },

    computed: {

        iconSource: function () {
            const color = window.innerWidth < configuration.size.tablet ? 'blue' : 'grey'
            return this.encrypt ? `/img/icons/eye-close-${color}.svg` : `/img/icons/eye-open-${color}.svg`
        },

        iconAlt: function () {
            return this.encrypt ? 'password visibility off' : 'password visibility on'
        },

        iconAltError: function () {
            return this.encrypt ? 'password visibility off error' : 'password visibility on error'
        },

        iconErrorSource: function () {
            return this.encrypt ? '/img/icons/eye-close-red.svg' : '/img/icons/eye-open-red.svg'
        },

        compuType: function () {

            switch (this.type) {
                case 'password':
                    return this.encrypt ? 'password' : 'text'
                case 'year':
                    return 'number'
                default:
                    return this.type || 'text'
            }
        },

        invalid: function () {
            return this.valid === 'invalid'
        }
    },

    mounted() {
        if (this.data) {
            this.value = this.data
        }

        if (this.boolFocus) {
            this.focus()
        }
    },

    methods: {

        // call By parent
        focus() {
            this.$refs.input.focus()
        },

        enter() {
            this.$emit('pressEnter')
        },

        onBlur() {

            this.inputFocus = false
            this.$emit('blur')
        },

        eventFocus() {
            this.inputFocus = true
            this.$emit('focus')
        },

        eventChange() {
            this.showError = false
            this.$emit('restart')
            this.focus()
        },

        change() {
            this.$emit('change', this.$refs.input.value)
        }
    }

}

</script>

<style lang="scss" scoped>

.input-container-c {
    position: relative;
    height: 40px;
    border-radius: 100px;
    background-color: $white-input;
    border: 1px solid $grey;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: $above-tablet-length) {
        height: 56px;
    }
}

.input-focus {
    border-color: $blue;
}

.input-text-c {
    background-color: $white-input;
    margin: 0 16px;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    caret-color: $blue-caret;
    -moz-appearance: textfield;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 18px;
    }

    &:lang(ar-sa) {
        margin: 16px;
        text-align: right;
    }
}

.big-select {
    height: 56px;
}

.ico-input-check {
    position: absolute;
    right: 16px;
    width: 16px;
    height: 16px;
    @media screen and (min-width: $above-tablet-length) {
        width: 24px;
        height: 24px;
    }

    &:lang(ar-sa) {
        right: unset;
        left: 16px;
    }
}

.light-border {
    border-color: $white;
}

.light-border-focus {
    border-color: $grey;
}

.error {
    border-color: $raspberry;
}

.tooltip-error {
    position: relative;
    width: 224px;
    background-color: white;
    position: absolute;
    left: 0;
    top: -46px;
    @media screen and (min-width: $above-tablet-length) {
        width: inherit;
    }
}

.tooltip-error-text {
    width: 100%;
    color: $raspberry;
    text-align: start;
    padding: 8px;
    font-size: 14px;
    font-weight: 500;
}

.tooltip-arrow-container {
    position: relative;
    width: 1px;
    height: 1px;
    margin: 0 auto;
}

.tooltip-arrow {
    width: 15px;
    height: 15px;
    transform: rotate(45deg);
    background-color: $white;
    margin: 0 auto;
    position: absolute;
    bottom: -4px;
}

.span-error-text {
    font-size: 13px;
    color: $raspberry;
    text-align: start;
    width: 100%;
    margin-top: 4px;
}

</style>
